import { makeStyles, useTheme } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { getFriendlyTeamName } from '../../utils/gameUtils';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Container from '@material-ui/core/Container';
import {
    useParams
} from "react-router-dom";
import { getFriendlyGameDate, formatGameTime } from '../../utils/timeFormat'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { OddsEventMobileUI } from './mobileUI'
import OddsEventBrowserUI from './browserUI'
// import OddsEventSeo from './OddsEventSeo';
import {
    MobileView,
} from "react-device-detect";
import { styles } from './OddsEventStyles';
import { useGameQuery } from '../../hooks/useGameQuery';
import { useConfigQuery } from '../../hooks/useConfigQuery';
import ErrorView from '../../components/errors/ErrorView';
export default function OddsEvent() {
    const classes = styles();
    const theme = useTheme();
    const { league, gameSlug } = useParams();
    const [marketFilter, setMarketFilter] = useState(league.toLowerCase() === 'nhl' || league.toLowerCase() === 'mlb' ? '2way' : 'spread');
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));

    const [awayTeam, rhs] = gameSlug.split('-vs-');
    const [homeTeam, dateSlug] = rhs.split('-odds-');

    const { availableSportsBooks } = useConfigQuery();
    const { game, isError } = useGameQuery(league, awayTeam, homeTeam, dateSlug);

    const onFilterChanged = (filter) => {
        localStorage.setItem('marketFilter', filter);
        setMarketFilter(filter);
    }

    if (isError) {
        return <ErrorView />;
    }
    if (!game) {
        return null;
    }

    return (
        <>
            {/*<OddsEventSeo */}
            {/*    homeTeam={homeTeam} */}
            {/*    awayTeam={awayTeam}*/}
            {/*    homeFullTeamName={game.competitors.home.name} */}
            {/*    awayFullTeamName={game.competitors.away.name}*/}
            {/*    gameDate={new Date(game.scheduled)} league={league} */}
            {/*/>*/}
            <Container className={classes.contentContainer}>
                <EventPageHeader
                    gameStatus={game.status}
                    league={league}
                    homeTeam={game.competitors.home}
                    awayTeam={game.competitors.away}
                    gameDate={game.scheduled_datetime}
                />
                <div className={classes.mobileMarketFilter}>
                    <MobileView>
                        <div>
                            <MarketFilter league={league} marketFilter={marketFilter} onFilterChanged={onFilterChanged} />
                        </div>
                    </MobileView>
                </div>
                {isLargeScreen && (
                    <OddsEventBrowserUI
                        availableSportsBooks={availableSportsBooks}
                        classes={classes}
                        game={game}
                        marketFilter={marketFilter}
                        league={league}
                    />
                )}
                {!isLargeScreen && (
                    <OddsEventMobileUI
                        classes={classes}
                        availableSportsBooks={availableSportsBooks}
                        game={game}
                        marketFilter={marketFilter}
                        league={league}
                    />
                )}
            </Container>
        </>
    );
};

const eventPageHeaderStyles = makeStyles(theme => ({
    vs: {
        fontSize: 28,
        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },
    container: {
        marginTop: 37,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: 'proxima-nova',

        "& h3": {
            margin: 0,
            padding: 0,
            fontFamily: 'proxima-nova',
            fontWeight: 800,
            marginRight: 8,
            fontSize: '35px',
            lineHeight: '100%',
            [theme.breakpoints.down('xs')]: {
                fontSize: '25px',
            },
            letterSpacing: '-1px',
            textTransform: 'uppercase',
            color: '#000000',
        },
        "& p": {
            marginTop: '4px',
            fontFamily: 'proxima-nova',
            padding: 0,
            fontSize: 14,
            fontWeight: 400
        }
    },

}));
const EventPageHeader = ({ league, gameStatus, homeTeam, awayTeam, gameDate }) => {
    const classes = eventPageHeaderStyles();
    const awayTeamName = getFriendlyTeamName(league, homeTeam, true);
    const homeTeamName = getFriendlyTeamName(league, awayTeam, true);

    function getFriendlyGameTime(d) {
        d = new Date(d);
        const date = getFriendlyGameDate(d, true);

        return date + " " + formatGameTime(d);
    }

    const isPostponed = gameStatus === 'postponed';
    const isCancelled = gameStatus === 'cancelled';
    const isClosed = gameStatus === 'closed';


    return (
        <div className={classes.container}>
            <h3>
                <span>{homeTeamName}</span>
                <span className={classes.vs}> vs </span>
                <span>{awayTeamName}</span>
            </h3>
            <h3>
                <span> ODDS</span>
            </h3>
            {isPostponed ? <p>Postponed</p> : isCancelled ? <p>Cancelled</p> : isClosed ? <p>Closed</p> : <p>{getFriendlyGameTime(gameDate).toLocaleUpperCase()}</p>}
        </div>
    )
}


const eventBetTypeStyles = makeStyles(theme => ({
    tabs: {
        [theme.breakpoints.up('lg')]: {
            borderTop: '1px solid #D1CFD7'
        },
        borderBottom: '1px solid #D1CFD7',
    },
}));

const PuckLinesTab = withStyles((theme) => ({
    root: {
        minWidth: 63,
        padding: 0,
        marginLeft: '15px',
        fontFamily: 'proxima-nova',
        fontWeight: '400'
    },
}))(Tab);

const RunLinesTab = withStyles((theme) => ({
    root: {
        minWidth: 63,
        padding: 0,
        marginLeft: '15px',
        fontFamily: 'proxima-nova',
        fontWeight: '400'
    },
}))(Tab);

const SpreadsTab = withStyles((theme) => ({
    root: {
        minWidth: 63,
        padding: 0,
        marginLeft: '15px',
        fontFamily: 'proxima-nova',
        fontWeight: '400'
    },
}))(Tab);

const MoneylineTab = withStyles((theme) => ({
    root: {
        minWidth: 63,
        padding: 0,
        marginLeft: '15px',
        fontFamily: 'proxima-nova',
        fontWeight: '400'
    }
}))(Tab);

const TotalsTab = withStyles((theme) => ({
    root: {
        minWidth: 63,
        padding: 0,
        marginLeft: '15px',
        fontFamily: 'proxima-nova',
        fontWeight: '400'
    }
}))(Tab);

const MarketFilter = ({ league, marketFilter, onFilterChanged }) => {
    const classes = eventBetTypeStyles();
    const [value, setValue] = React.useState(marketFilter);

    const leagueName = league.toLowerCase();

    const handleChange = (event, newValue) => {
        setValue(newValue);

        if (onFilterChanged)
            onFilterChanged(newValue);
    };

    return (
        <Tabs className={classes.tabs} value={value} onChange={handleChange}>
            {
                (leagueName === 'mlb' || leagueName === 'nhl') &&
                <MoneylineTab value={'2way'} label="MONEYLINE" />
            }
            {
                leagueName === 'nhl' &&
                <PuckLinesTab value={'puck_line'} label="PUCK LINES" />
            }
            {
                leagueName === 'mlb' &&
                <RunLinesTab value={'run_line'} label="RUN LINES" />
            }
            {
                leagueName !== 'mlb' && leagueName !== 'nhl' &&
                <SpreadsTab value={'spread'} label="SPREADS" />
            }
            {
                leagueName !== 'mlb' && leagueName !== 'nhl' &&
                <MoneylineTab value={'2way'} label="MONEYLINE" />
            }
            <TotalsTab value={'total'} label="TOTALS" />
        </Tabs>
    );
}